export default __webpack_public_path__ + "images/0397ec4a67980009c8781d089281521e.png";